/// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/component.ts" />

declare var irep: IREP.IREP;

namespace IREP {

    export class VideoTrackingV3 extends Component {
        private beginLog: boolean;
        private endLog: boolean;
        private middleLog: boolean;
        private _video: any;
        private videoURL: string;
        private videoId: string;

        constructor(id: string) {
            super(id);
                        
            this.beginLog = false;
            this.endLog = false;
            this.middleLog = false;
            this._video = document.getElementById(id);
            this.videoURL = this._video.currentSrc;
            this.videoId = id;
            
            var media_properties = ["currentTime", "duration"];

            if (this._video.getElementsByTagName("source").length > 0) {
                this._video.addEventListener("durationchange", (e) => this.capture(e), false);
                this._video.addEventListener("timeupdate", (e) => this.capture(e), false);                
            }
        }

        private capture(e: JQueryEventObject) {
            if ((this._video.currentTime > 1) && !this.beginLog) {
                this.logVideo(1);
                this.beginLog = true;
            } else if ((this._video.currentTime > (this._video.duration / 2)) && !this.middleLog) {
                this.logVideo(3);
                this.middleLog = true;
            } else if ((this._video.currentTime > (this._video.duration - 5)) && !this.endLog) {
                this.logVideo(2);
                this.endLog = true;
            }
        };

        private activityCode() {
            var regex = new RegExp("[\\?&]code=([^&#]*)"),
                results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }

        public logVideo(viewType) {

            irep.callApi({
                url: '/videotracker',
                type: 'POST',
                data: {
                    ViewType: viewType,
                    Source: null,
                    URL: this.videoURL,
                    ActivityCode: this.activityCode,
                    ISANumber: null
                }
            });
        }
    }
}

irep.ready(function () {
    $('video').each(function () {
        var vp = new IREP.VideoTrackingV3(this.id);
    });
});